import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { OpenOrdersReportDocument } from '../../../../models/accounting/shared/open-orders-report-document';

export const OpenOrders = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const [, setStartDate] = React.useState(new Date());
    const [, setEndDate] = React.useState(new Date());
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setIsOpen(false);
    };

    /**
     * Format the dates and initiate the AccountMate report command
     */
    const runReport = () => {                    
        const today = new Date();
        const req = new OpenOrdersReportDocument(today);
        dispatch(getDocumentHelper(req));
        onCloseClick();
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Open Orders</h3>
                                <p>Obtain a list of all open orders.</p>
                            </div>
                        </div>
                    
                        <div className="row">
                            <div className="col">
                            <DialogTrigger
                                onClick={ onOpenClick }
                                text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={ isOpen }
                className="report-dialog"
                onClose={ onCloseClick }
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Open Orders Report</h1>
                </DialogHeader>

                <DialogContent>
                    <div className="row">
                        <div className="col">
                            <p className="callout">
                                Get a full export in Excel format of all the open orders in the system.
                            </p>                            
                        </div>
                    </div>                    
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="accountmateNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={ onCloseClick } />
                    <FlatButton
                        id="accountmateYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={ runReport } />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
